export default __webpack_public_path__ + "static/media/google-partner-badge.f2e0b771.png";